import { Injectable } from '@angular/core';
import { Countries } from 'projects/zbs-app/src/app/services/Ebootis.Queries/Countries';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class CountrySelectService {

	constructor(
		private m_queryService: Countries
	) { }

	/**
	 * Liefert das Ergebnis des Queries für Countries zurück.
	 */
	public getCountries(): Observable<Countries.Result[]> {
		return this.m_queryService.query().pipe(
			switchMap((results: any[]) => {
				results.sort((a, b) => a.name.localeCompare(b.name));
				const temp = [];
				results.forEach((resultEl) => {
					if (temp.find((tempEl) => tempEl.iso == resultEl.iso) == undefined) {
						temp.push(resultEl);
					}
				});
				return of(temp);
			})
		);
	}
}
